module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_forgot_remoteEntry_mjs_7775737f__;